/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export const INVENTORY_BULK_UPLOAD_SUPPORTED_FILES = ["csv"]
export const MENU_BULK_UPLOAD_SUPPORTED_FILES = [
  "csv", // csv is the legacy supported method, we still support the legacy method although on UI we only mention zip file
  "zip",
  "x-zip",
  "x-zip-compressed",
]
export const ECOMMERCE_BULK_UPLOAD_SUPPORTED_FILES = [
  "zip",
  "x-zip",
  "x-zip-compressed",
]
export const BULK_UPLOAD_TABLE_RECORD_LIMIT = 10
export const BULK_TASK_POLLING_INTERVAL = 15000 // 15s
export const BULK_TASK_STOP_POLLING_IDLE_WAIT_TIME = 30000 // 30s

export enum BULK_UPLOAD_EXPORT_FILE_FIELDS {
  categoryNameInput = "categoryNameInput",
  categoryCheckboxGroup = "categoryCheckboxGroup",
  categoryItemStatus = "categoryItemStatus",
  menuItemProperty = "menuItemProperty",
}

// Help center links for bulk upload inventory, organized by country and language.
// Format: { country: { language: url } }
// Note: Per country team preference, countries without dedicated "en" links use their localized link
export const HELP_CENTER_BULK_UPLOAD_INVENTORY_LINKS: Record<
  string,
  Record<string, string>
> = {
  id: {
    id: "https://help.grab.com/merchant/id-id/12740059711385",
    en: "https://help.grab.com/merchant/id-id/12740059711385",
  },
  vn: {
    vi: "https://help.grab.com/merchant/vi-vn/12740059711385",
    en: "https://help.grab.com/merchant/vi-vn/12740059711385",
  },
  ph: {
    en: "https://help.grab.com/merchant/en-ph/12740059711385",
  },
  sg: {
    en: "https://help.grab.com/merchant/en-sg/12740059711385",
  },
  my: {
    ms: "https://help.grab.com/merchant/ms-my/12740059711385",
    en: "https://help.grab.com/merchant/en-my/12740059711385",
  },
  th: {
    th: "https://help.grab.com/merchant/th-th/12740059711385",
    en: "https://help.grab.com/merchant/en-th/12740059711385",
  },
  mm: {
    my: "https://help.grab.com/merchant/my-mm/12740059711385",
    en: "https://help.grab.com/merchant/my-mm/12740059711385",
  },
  kh: {
    km: "https://help.grab.com/merchant/km-kh/12740059711385",
    en: "https://help.grab.com/merchant/en-kh/12740059711385",
  },
}

// Help center links for bulk upload menu, organized by country and language.
// Format: { country: { language: url } }
// Note: Per country team preference, countries without dedicated "en" links use their localized link
export const HELP_CENTER_BULK_UPLOAD_MENU_LINKS: Record<
  string,
  Record<string, string>
> = {
  id: {
    id: "https://help.grab.com/merchant/id-id/24772842778393",
    en: "https://help.grab.com/merchant/id-id/24772842778393",
  },
  vn: {
    vi: "https://help.grab.com/merchant/vi-vn/24772842778393",
    en: "https://help.grab.com/merchant/vi-vn/24772842778393",
  },
  ph: {
    en: "https://help.grab.com/merchant/en-ph/24772842778393",
  },
  sg: {
    en: "https://help.grab.com/merchant/en-sg/24772842778393",
  },
  my: {
    ms: "https://help.grab.com/merchant/ms-my/24772842778393",
    en: "https://help.grab.com/merchant/en-my/24772842778393",
  },
  th: {
    th: "https://help.grab.com/merchant/th-th/24772842778393",
    en: "https://help.grab.com/merchant/en-th/24772842778393",
  },
  mm: {
    my: "https://help.grab.com/merchant/my-mm/24772842778393",
    en: "https://help.grab.com/merchant/my-mm/24772842778393",
  },
  kh: {
    km: "https://help.grab.com/merchant/km-kh/24772842778393",
    en: "https://help.grab.com/merchant/en-kh/24772842778393",
  },
}

// Help center links for bulk upload mart menu, organized by country and language.
// Format: { country: { language: url } }
// Note: Per country team preference, countries without dedicated "en" links use their localized link
export const HELP_CENTER_BULK_UPLOAD_MART_MENU_LINKS: Record<
  string,
  Record<string, string>
> = {
  id: {
    id: "https://help.grab.com/merchant/id-id/40001523",
    en: "https://help.grab.com/merchant/id-id/40001523",
  },
  vn: {
    vi: "https://help.grab.com/merchant/vi-vn/40001523",
    en: "https://help.grab.com/merchant/vi-vn/40001523",
  },
  ph: {
    en: "https://help.grab.com/merchant/en-ph/40001523",
  },
  sg: {
    en: "https://help.grab.com/merchant/en-sg/40001523",
  },
  my: {
    ms: "https://help.grab.com/merchant/ms-my/40001523",
    en: "https://help.grab.com/merchant/en-my/40001523",
  },
  th: {
    th: "https://help.grab.com/merchant/th-th/40001523",
    en: "https://help.grab.com/merchant/en-th/40001523",
  },
  mm: {
    my: "https://help.grab.com/merchant/my-mm/40001523",
    en: "https://help.grab.com/merchant/my-mm/40001523",
  },
  kh: {
    km: "https://help.grab.com/merchant/km-kh/40001523",
    en: "https://help.grab.com/merchant/en-kh/40001523",
  },
}

/**
 * Get help center bulk upload link with fallback to Singapore (sg) and English (en)
 * @param links - The help center links object
 * @param country - Country code (e.g., 'SG', 'TH', 'ID')
 * @param language - Language code (e.g., 'en', 'th', 'id')
 * @returns The help center link URL
 */
export const getHelpCenterBulkUploadLink = (
  links: Record<string, Record<string, string>>,
  country: string,
  language: string,
): string => {
  // Try to get the link for the specified country and language
  const countryLinks = links[country.toLowerCase()]
  if (countryLinks) {
    const link = countryLinks[language.toLowerCase()]
    if (link) {
      return link
    }
  }

  // Fallback to sg and en
  return links.sg?.en ?? ""
}
